import styled from '@emotion/styled';
import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Heading, Icon, Button, ActionIcon } from '../../common';
import SearchableDropdown from '../../components/form/SearchableDropdown';

// const IconCustom = styled(Icon)`
//   font-size: 0.75rem;
//   // margin-top: 7px;
// `;
const IconCustom = styled(Icon)`
  font-size: 0.75rem;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: none;
  outline: none;
  box-shadow: none;
  padding: 0;
  margin: 0;

  &:focus {
    outline: none;
    box-shadow: none;
  }

  &:active {
    outline: none;
    box-shadow: none;
  }
`;

const FormContainer = styled.div`
  display: flex;
  width: 100%;
  min-width: 22px;
  max-width: 100%;
  padding: 0 8px;
  margin: 0;
  border: ${props => (props.color ? `1px solid ${props.color}` : `1px solid var(--greyBorder)`)};
  transition: min-width 0.3s ease-in-out;
  border-radius: 20px;
  cursor: text;
  .css-tlfecz-indicatorContainer {
    display: none;
  }
  form {
    flex: 1;
    display: flex;
    align-items: center;
    min-width: 0;
    cursor: text;
  }

  input {
    flex-grow: 1;
    min-width: 22px;
    font-size: 12px;
    font-weight: 500;
    color: ${props => (props.color ? props.color : `var(--white)`)};
    padding: 6px;
    transition: min-width 0.3s ease-in-out;
    cursor: text;
  }

  input:focus {
    min-width: 22px;
  }
  span {
    align-self: flex-end;
    margin-bottom: 0.5rem;
  }
`;

const customeStylesField = {
  container: (provided, state) => ({
    ...provided,
    border: 0,
    borderRadius: 0,
    cursor: 'text'
  }),

  valueContainer: (provided, state) => ({
    ...provided,
    cursor: 'text',
    ...state.selectProps.valueContainerStyle
  }),

  control: (provided, state) => ({
    ...provided,
    outline: 0,
    borderRadius: 0,
    border: 0,
    background: 'transparent',
    borderColor: state.isFocused ? 'var(--inputColor)' : 'var(--borderColor)',
    boxShadow: 'none',
    minHeight: '30px',
    cursor: 'text',
    '&:hover': {
      borderColor: state.isFocused ? 'var(--inputColor)' : 'var(--borderColor)',
      cursor: 'text'
    },
    ...state.selectProps.controlStyle
  }),

  menu: (provided, state) => ({
    ...provided,

    borderRadius: '5px',
    width: 'auto',
    padding: '0 10px',
    background: '#8A8A8A',
    zIndex: 99999,
    boxShadow: 'none',
    textAlign: 'left'
  }),
  
    menuList: (provided, state) => ({
    ...provided,
    maxHeight: '180px',
    overflowY: 'auto',
    borderRadius: '5px',
    padding: '0 10px',
    background: '#8A8A8A',
    zIndex: 99999
  }),

  option: (provided, state) => ({
    fontSize: '0.75rem',
    fontWeight: '500',
    color: 'var(--white)',
    padding: '0px 3px',
    textAlign: 'left',
    cursor: 'pointer',

    '&:last-child': {
      borderBottom: 0
    }
  }),

  input: (provided, state) => ({
    ...provided,
    margin: '1px',
    fontSize: '11px',
    fontWeight: '500',
    color: 'var(--white)',
    cursor: 'text',
    ...state.selectProps.inputStyle
  }),

  singleValue: (provided, state) => ({
    fontSize: state.selectProps.selectedFontSize ? state.selectProps.selectedFontSize : '11px',
    fontWeight: state.selectProps.selectedFontWeight ? state.selectProps.selectedFontWeight : '500',
    color: state.selectProps.selectedColor ? state.selectProps.selectedColor : 'var(--white)',
    cursor: 'text',
    pointerEvents: 'none',
    ...state.selectProps.singleValueStyle
  }),

  indicatorSeparator: () => ({
    display: 'none'
  }),
  IndicatorsContainer: () => ({
    display: 'none'
  }),
  placeholder: () => ({
    fontSize: '0.75rem',
    color: 'var(--mediumGrey)',
    cursor: 'text'
  })
};

function Input({
  submit,
  key,
  className,
  value,
  color = { tagColor },
  singleValueStyle,
  onUpdateTagList,
  filters,
  tagsList,
  tagDeleted,
  Options,
  setTagsList,
  clipData,
  questionType_ID,
  notifyTagOperation
}) {
  const formRef = useRef(null);
  const [edit, setEdit] = useState(false);
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const loggedUser = useSelector(state => state.LoginReducer);
  const dispatch = useDispatch();
  const { id: routeProjectId } = useParams();
  const storeProjectId = useSelector(state => state.ProjectReducer.project_ID);
  const projectId = routeProjectId || storeProjectId;

  const [text, setText] = useState({ value: value.tag_ID, label: value.tagName, table_ID: value.table_ID });
  const [masterTagList, setMasterTagList] = useState([]);
  const resolvedClipId = clipData?.projectRepondentVideo_ID || clipData?.questionAnswerImage_ID;
  const resolvedQuestionTypeId = questionType_ID || clipData?.questionType_ID || 13;
  
  useEffect(() => {
    setText({ value: value.tag_ID, label: value.tagName, table_ID: value.table_ID });
  }, [value.tag_ID, value.table_ID, value.tagName]);

  const isDraftId = id => {
    const currentId = String(id || '');
    return !currentId || currentId.startsWith('temp_');
  };

  const saveNewTag = newTagValue => {
    const trimmed = (newTagValue || '').trim();
    if (!trimmed) {
      return;
    }

    const addPayload = {
      user_ID: loggedUser.userId,
      projectTagName: trimmed,
      project_ID: projectId,
      clip_ID: resolvedClipId,
      questionType_ID: resolvedQuestionTypeId,
      mediaAnswerID: clipData.questionAnswerImage_ID || null
    };

    dispatch({ type: 'REQUEST_ADDVIDEOTAG', payload: addPayload });
    notifyTagOperation?.('add');

    const newTagId = Date.now().toString();
    const newTag = {
      tag_ID: newTagId,
      tagName: trimmed,
      table_ID: newTagId
    };
    const updatedTagsList = tagsList.filter(tag => tag.tag_ID !== value.tag_ID);
    onUpdateTagList([...updatedTagsList, newTag]);
    setText({ value: newTagId, label: trimmed, table_ID: newTagId });
    setEdit(false);
    setMenuIsOpen(false);

    window.isTagAdded = true;
    window.dispatchEvent(new Event('tagAdded'));
  };

  const handleSubmit = e => {
    e.preventDefault();
    if (isDraftId(text.value)) {
      saveNewTag(text.label);
    }
  };

  useEffect(() => {
    const safeOptions = Array.isArray(Options) ? Options : [];
    const formattedTags = safeOptions
      .filter(option => option?.tag_ID || option?.value)
      .map(option => ({
        value: option.tag_ID || option.value,
        label: option.tag || option.tagName || option.label
      }));
    setMasterTagList(formattedTags);
  }, [Options]);

  useEffect(() => {
    const handleOutsideForm = e => {
      if (formRef.current && !formRef.current.contains(e.target)) {
        setEdit(false);
      }
    };
    document.addEventListener('click', handleOutsideForm);
    return () => {
      document.removeEventListener('click', handleOutsideForm);
    };
  }, []);

  const updateTag = (tag_id, newTagValue) => {
    window.isTagAdded = true;
    window.dispatchEvent(new Event('tagAdded'));
    
    const deletePayload = {
      user_ID: loggedUser.userId,
      tag_ID: tag_id
    };
    dispatch({ type: 'REQUEST_DELETEVIDEOTAG', payload: deletePayload });

    const addPayload = {
      user_ID: loggedUser.userId,
      projectTagName: newTagValue,
      project_ID: projectId,
      clip_ID: resolvedClipId,
      questionType_ID: resolvedQuestionTypeId,
      tag_ID: tag_id,
      mediaAnswerID: clipData.questionAnswerImage_ID || null
    };

    notifyTagOperation?.('update', addPayload);

    let index = tagsList.findIndex(tag => tag.tag_ID === tag_id);
    if (index !== -1) {
      const tempTagsList = tagsList.map((tag, tagIndex) =>
        tagIndex === index ? { ...tag, tagName: newTagValue } : tag
      );
      onUpdateTagList(tempTagsList);
    }

    setEdit(false);
  };

  const handleDropdownChange = opt => {
    if (!opt?.label) {
      return;
    }
    setText({ ...text, label: opt.label, value: opt.value });

    if (isDraftId(text.value)) {
      saveNewTag(opt.label);
      return;
    }
    updateTag(text.value, opt.label);
  };

  const onClickInput = e => {
    setEdit(true);
    const input = formRef.current?.querySelector('input');
    if (input && e.target !== input) {
      e.preventDefault();
      input.focus();
    }
  };

  const deleteTag = (tag_id, table_ID) => {
    // let payload = {
    //   user_ID: loggedUser.userId,
    //   ...(clipData?.questionAnswerImage_ID
    //     ? { tag_ID: table_ID } // Use the passed table_ID
    //     : clipData?.projectRepondentVideo_ID
    //     ? { tag_ID: tag_id } // Corrected key from tag_id to tag_ID for consistency
    //     : {})
    // };
    let payload = {
      user_ID: loggedUser.userId,
      tag_ID: table_ID
    };

    tagDeleted(tag_id);
    dispatch({
      type: 'REQUEST_DELETEVIDEOTAG',
      payload
    });
    notifyTagOperation?.('delete');
  };

  return (
    <div className="mt-1 mb-1 mr-1">
      <FormContainer ref={formRef} color={color} className={className} disable={!edit}>
        <form onSubmit={handleSubmit} onMouseDown={onClickInput}>
          <SearchableDropdown
            isSearchable
            singleValueStyle={singleValueStyle}
            valueContainerStyle={{
              padding: edit ? '0 10px 0 0px' : '0 0px 0 0px'
            }}
            controlStyle={{ minHeight: 'auto' }}
            inputStyle={{
              color: color
            }}
            selectedColor={color}
            value={text.label ? text : null}
            defaultValue={text}
            Options={Options}
            masterTagList={masterTagList}
            setMasterTagList={setMasterTagList}
            onChange={handleDropdownChange}
            menuIsOpen={menuIsOpen}
            setMenuIsOpen={setMenuIsOpen}
            crossOption={false}
            customStylesForDropdown={customeStylesField}
          />
        </form>

        <div style={{ height: '12px', paddingTop: '4px' }}>
          {!edit && (
            <IconCustom
              color={color}
              onClick={e => {
                deleteTag(text.value, text.table_ID);
              }}
              style={{ cursor: 'pointer' }}
            >
              close
            </IconCustom>
          )}
        </div>
      </FormContainer>
    </div>
  );
}

const getTagSignature = tags =>
  JSON.stringify(
    (Array.isArray(tags) ? tags : []).map(
      tag => `${tag.table_ID || ''}|${tag.tag_ID || ''}|${tag.tagName || tag.tag || ''}`
    )
  );

const isDraftTag = tag => {
  const tagId = String(tag?.tag_ID || '');
  const tableId = String(tag?.table_ID || '');
  return (
    tagId.startsWith('temp_') ||
    tableId.startsWith('temp_') ||
    !(tag?.tagName || tag?.tag || '').trim()
  );
};

function EditingTagAnalysis({
  tagColor,
  addTagButtonColor = 'var(--greyBorder)',
  AddTagButton,
  singleValueStyle,
  tagList,
  onUpdateTagList,
  filters,
  clipId,
  clipData,
  Options,
  questionType_ID,
  projectId,
  selectedRespondantVideoId,
  qid,
  props
}) {
  const [tagsList, setTagsList] = useState([]);
  const [showResults, setShowResults] = useState(false);
  const [hasInitialized, setHasInitialized] = useState(false);
  const [pendingTagOp, setPendingTagOp] = useState(null);
  const pendingAddPayload = useRef(null);
  const safeOptions = Array.isArray(Options) ? Options : [];
  const dispatch = useDispatch();
  const { id: routeProjectId } = useParams();
  const storeProjectId = useSelector(state => state.ProjectReducer.project_ID);
  const resolvedProjectId = projectId || routeProjectId || storeProjectId;
  const addTagReceived = useSelector(state => state.AddVideoTagReducer?.received);
  const addTagData = useSelector(state => state.AddVideoTagReducer?.data);
  const deleteTagReceived = useSelector(state => state.DeleteVideoTagReducer?.received);
  const deleteTagData = useSelector(state => state.DeleteVideoTagReducer?.data);
  
  const clipsDataWithoutUrl = useSelector(state => state.analysisReducer?.clipsDataWithoutUrl);

  const notifyTagOperation = (op, addPayload = null) => {
    pendingAddPayload.current = addPayload;
    setPendingTagOp(op);
  };

  useEffect(() => {
    if (!pendingTagOp) {
      return;
    }

    if (pendingTagOp === 'update' && deleteTagReceived) {
      if (pendingAddPayload.current) {
        dispatch({ type: 'REQUEST_ADDVIDEOTAG', payload: pendingAddPayload.current });
        pendingAddPayload.current = null;
        setPendingTagOp('add');
      }
      return;
    }

    const addFinished = pendingTagOp === 'add' && addTagReceived;
    const deleteFinished = pendingTagOp === 'delete' && deleteTagReceived;

    if (!addFinished && !deleteFinished) {
      return;
    }

    if (!resolvedProjectId) {
      setPendingTagOp(null);
      return;
    }

    dispatch({
      type: 'REQUEST_ANALYSIS_CLIPS_DATA',
      payload: {
        project_ID: resolvedProjectId,
        AgeGroup: filters['AgeGroup'],
        MaritalStatus: filters['MaritalStatus'],
        Gender: filters['Gender'],
        classificationData: filters['classificationData'],
        UserType: filters['UserType'],
        Geography: filters['Geography'],
        Ownership: filters['Ownership'],
        CustomTags: filters['CustomTags'],
        CustomTags1: filters['CustomTags'],
        question_ID: qid
      }
    });

    dispatch({
      type: 'REQUEST_ANALYSIS_CLIPS_WITHOUT_URL',
      payload: {
        project_ID: resolvedProjectId,
        AgeGroup: filters['AgeGroup'],
        MaritalStatus: filters['MaritalStatus'],
        Gender: filters['Gender'],
        classificationData: filters['classificationData'],
        UserType: filters['UserType'],
        Geography: filters['Geography'],
        Ownership: filters['Ownership'],
        CustomTags: filters['CustomTags']
      }
    });
    dispatch({
      type: 'REQUEST_FILTER_DATA',
      payload: {
        payload: resolvedProjectId
      }
    });
    setPendingTagOp(null);
  }, [pendingTagOp, addTagReceived, addTagData, deleteTagReceived, deleteTagData, resolvedProjectId, filters, dispatch, qid]);

  const handleUpdateTagList = updatedTagList => {
    setTagsList(updatedTagList);
    onUpdateTagList(updatedTagList);
  };

  const tagListSignature = getTagSignature(tagList);

  useEffect(() => {
    const incoming = Array.isArray(tagList) ? tagList : [];

    setTagsList(prev => {
      const draftTags = (prev || []).filter(isDraftTag);
      if (draftTags.length) {
        const incomingKeys = new Set(incoming.map(tag => `${tag.table_ID || ''}-${tag.tag_ID || ''}`));
        const uniqueDrafts = draftTags.filter(
          draft => !incomingKeys.has(`${draft.table_ID || ''}-${draft.tag_ID || ''}`)
        );
        return [...incoming, ...uniqueDrafts];
      }

      if (getTagSignature(incoming) === getTagSignature(prev)) {
        return prev;
      }

      return incoming;
    });
    setHasInitialized(true);
  }, [tagList, tagListSignature]);
  
  useEffect(() => {
    if (!hasInitialized || !clipData || pendingTagOp) return;
    if (Number(questionType_ID) !== 10) return;
    if (!clipsDataWithoutUrl || Array.isArray(clipsDataWithoutUrl) || !clipsDataWithoutUrl.questionsAnalysisData) {
      return;
    }

    const resolvedClipId = clipData?.projectRepondentVideo_ID || clipData?.questionAnswerImage_ID;
    if (!resolvedClipId) return;

    let updatedClipData = null;
    if (clipsDataWithoutUrl?.questionsAnalysisData) {
      for (const section of clipsDataWithoutUrl.questionsAnalysisData) {
        if (section.questionName_array) {
          for (const question of section.questionName_array) {
            if (question.answer) {
              const foundAnswer = question.answer.find(
                ans =>
                  ans.projectRepondentVideo_ID === resolvedClipId ||
                  ans.questionAnswerImage_ID === resolvedClipId
              );
              if (foundAnswer) {
                updatedClipData = foundAnswer;
                break;
              }
            }
          }
          if (updatedClipData) break;
        }
      }
    }

    if (!updatedClipData) {
      return;
    }

    const updatedTags = Array.isArray(updatedClipData?.tags)
      ? updatedClipData.tags.map(tag => ({
          tag_ID: tag.tag_ID,
          tagName: tag.tag || tag.tagName,
          table_ID: tag.table_ID
        }))
      : [];

    setTagsList(prev => {
      if ((prev || []).some(isDraftTag)) {
        return prev;
      }

      if (getTagSignature(updatedTags) === getTagSignature(prev)) {
        return prev;
      }

      return updatedTags;
    });
  }, [clipsDataWithoutUrl, hasInitialized, clipData?.projectRepondentVideo_ID, clipData?.questionAnswerImage_ID, questionType_ID, pendingTagOp]);

  const handleAddtag = () => {
    const tempId = `temp_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
    const newTag = {
      tag_ID: tempId,
      tagName: '',
      table_ID: tempId,
      value: tempId,
      label: ''
    };
    handleUpdateTagList([...(tagsList || []), newTag]);
    setShowResults(true);
    setShowResults(false);
  };

  const removeTag = tag_id => {
    let index = tagsList.findIndex(tag => tag.tag_ID === tag_id);
    if (index !== -1) {
      let tempTagsList = [...tagsList];
      tempTagsList.splice(index, 1);
      handleUpdateTagList(tempTagsList);
      console.log('delete tag');
    } else {
      console.log('Tag Not Found');
    }
    // console.log('setShowResults', showResults);
  };

  return (
    <div style={{ width: '100%' }}>
      <div className="d-flex flex-column align-items-stretch" style={{ width: '100%' }}>
        {tagsList?.map((item, index) => (
          <Input
            submit={text => console.log(text)}
            key={item.table_ID || item.tag_ID}
            className=""
            value={item}
            color={tagColor}
            filters={filters}
            Options={safeOptions}
            singleValueStyle={singleValueStyle}
            onUpdateTagList={handleUpdateTagList}
            tagsList={tagsList}
            tagDeleted={removeTag}
            setTagsList={setTagsList}
            clipData={clipData}
            questionType_ID={questionType_ID}
            notifyTagOperation={notifyTagOperation}
          />
        ))}
        <div className="d-flex align-items-center" style={{ width: '100%' }} onClick={handleAddtag}>
          {!showResults ? (
            AddTagButton ? (
              <AddTagButton />
            ) : (
              <>
                <Icon style={{ fontSize: '16px' }} color={addTagButtonColor}>
                  add
                </Icon>{' '}
              </>
            )
          ) : (
            ''
          )}
        </div>
      </div>
    </div>
  );
}

export default EditingTagAnalysis;